const MOCHI_AUTH = 'mochi_auth';
const KEY_BARCODE_PAYMENT_RECEIPT_CODE_HIDDEN_STATE =
  'barcode_payment_receipt_code_hidden_state';
const KEY_BARCODE_PAYMENT_VIEWED_BOARD_LIST =
  'barcode_payment_viewed_board_list';

class Storage {
  getBarcodePaymentViewedBoardList = () => {
    return JSON.parse(
      localStorage.getItem(KEY_BARCODE_PAYMENT_VIEWED_BOARD_LIST),
    );
  };

  saveBarcodePaymentViewedBoardList = (id) => {
    let list = this.getBarcodePaymentViewedBoardList() || [];
    list.push(id);
    return localStorage.setItem(
      KEY_BARCODE_PAYMENT_VIEWED_BOARD_LIST,
      JSON.stringify(list),
    );
  };

  getBarcodePaymentReceiptCodeHiddenState = () => {
    return JSON.parse(
      localStorage.getItem(KEY_BARCODE_PAYMENT_RECEIPT_CODE_HIDDEN_STATE),
    );
  };

  saveBarcodePaymentReceiptCodeHiddenState = (bool) => {
    return localStorage.setItem(
      KEY_BARCODE_PAYMENT_RECEIPT_CODE_HIDDEN_STATE,
      bool,
    );
  };

  saveAuth = (obj) => {
    localStorage.setItem(MOCHI_AUTH, JSON.stringify(obj));
  };

  getAuth = () => {
    return this.parse(localStorage.getItem(MOCHI_AUTH));
  };

  parse = (obj) => {
    try {
      return JSON.parse(obj);
    } catch (e) {
      return null;
    }
  };
}

export default Storage;
